import { Divider, Drawer, Input, Space, Slider, Checkbox, Button, Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { useSession } from "../../../utils/Session";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import LinkUI from "../../UI/LinkUI";
import { useTemplate } from "../../../utils/Template";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning, tt_pun_padding_y, tt_pun_border_radius, tt_pun_gap, tt_pun_padding_x, previewLink } from "../../../utils/Utils";
import RichTextEditor from "../../UI/RichTextEditor";
import Html from "../../../utils/Html";
import LinkPicker from "../../../globals/styles/LinkPicker";

export default function PopupNotice(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template,] = useTemplate();
    const [session,] = useSession();
    const [content, setContent] = useState(props.content);
    const [open, setOpen] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        background_colour = 0,
        background_radius = 0,
        width = 250,
        gap = 10,
        text_align = "center",
        padding_x = 20,
        padding_y = 20,
        heading = "Popup Notice",
        heading_preset = 0,
        paragraph = "",
        paragraph_preset = 0,
        link_button = false,
        link_button_label = "",
        link_button_url = "",
        link_button_type = 0,
        button_label = "",
        button_type = 0,
        button_block = false,
        link_id = 0,
        show_once = false,
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = () => {
        if (link_button_url) {
            window.open(previewLink(link_button_url), "_blank");
        }
    }

    const modalRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            alignSelf: "flex-end",
            textAlign: text_align,
        }

        let bg_style = {
            backgroundColor: getColor(background_colour, template, "#fff"),
            borderRadius: background_radius + "px",
            border: "1px solid " + getColor(background_colour, template, "#fff"),
            maxWidth: width + "px",
            margin: "0 auto",
            boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.5)",
        }

        return (
            <div style={bg_style}>
                <div style={_style}>
                    {(heading &&
                        <h4 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                            {heading}
                        </h4>
                    )}
                    <div className="shim" style={{ "height": gap + "px" }} />
                    {(paragraph &&
                        <p className={"bm-txt-" + paragraph_preset} >
                            <Html anchor={"bm-lnkin-" + link_id} html={paragraph} />
                        </p>
                    )}
                    {(link_button_label && link_button &&
                        <div style={{ "display": "block" }}>
                            <div className="shim" /><div className="shim" />
                            <Button block={button_block} onClick={() => linkOut()} className={"bm-btn-" + link_button_type} >{link_button_label}</Button>
                        </div>
                    )}
                    {(button_label &&
                        <div onClick={() => setOpen(false)} style={{ "display": "block" }}>
                            <Button block={button_block} className={"bm-btn-" + button_type} >{button_label}</Button>
                        </div>
                    )}
                </div>
            </div>
        )
    }


    useEffect(() => {
        if (session.is_editing !== true) {
            setOpen(true);
        }
    }, [])

    const drawRender = () => {
        if (session.is_editing === false) {
            return (
                <Modal
                    className="bm-pop-up"
                    width={width}
                    onCancel={() => setOpen(false)}
                    modalRender={modalRender}
                    open={open}>
                </Modal>
            )
        }
        return (
            <div style={{ "margin": "20px 0px" }}>
                {modalRender()}
            </div>
        )
    }

    const formatter = (value) => `${value}px`;

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading hide_container={true} menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SUPPRESS POPUP</Divider>
                <Checkbox checked={show_once} onChange={(e) => setData({ ...data, "show_once": e.target.checked })} ><small>Only show popup once per visit?</small></Checkbox>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />



                {/* BACKGROUND BORDER RADIUS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND BORDER RADIUS</Divider>
                <BMInput width={"40px"} value={background_radius} onChange={(e) => setData({ ...data, "background_radius": e })} number min={0} max={1000} prefix={<Tooltip title={tt_pun_border_radius}>RADIUS</Tooltip>} />
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "150px" }}
                        tooltip={{
                            formatter,
                        }}
                        min={100}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div style={{ "marginTop": "4px" }}>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <Space>
                        <BMInput width={30} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pun_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={30} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pun_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GAP</Divider>
                <BMInput width={30} value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={<Tooltip title={tt_pun_gap}>GAP</Tooltip>} />
                <div className="shim" /><div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                    <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                    <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                    <RichTextEditor link_id={link_id} background_colour_default={getColor(background_colour, template, "#fff")} paragraph_preset={paragraph_preset} background_colour={background_colour} padding_x={padding_x} padding_y={padding_y} width={width} value={paragraph} onChange={(_v) => setData({ ...data, "paragraph": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />
                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />

                {/* LINK BUTTON */}
                <Checkbox checked={link_button} onChange={(e) => setData({ ...data, "link_button": e.target.checked })} ><small>Add Link Button?</small></Checkbox>
                <div className="shim" /> <div className="shim" />
                <div style={{ display: link_button ? "block" : "none" }}>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK BUTTON LABEL</Divider>
                    <Input disabled={!link_button} style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "link_button_label": e.target.value })} value={link_button_label} placeholder="Label..." />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK BUTTON TYPE</Divider>
                    <ButtonPicker value={link_button_type} onChange={(e) => setData({ ...data, "link_button_type": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK BUTTON URL</Divider>
                    <LinkUI value={link_button_url} onChange={(e) => setData({ ...data, "link_button_url": e })} />
                    <div className="shim" /> <div className="shim" />
                    <div className="shim" /> <div className="shim" />
                </div>

                {/* CLOSE BUTTON */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CLOSE BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CLOSE BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Checkbox disabled={(!button_label && !link_button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
                <div className="shim" /> <div className="shim" />


            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}